import { cn } from '../../lib/utils';

export const getRiskLevel = (score) => {
  if (score >= 15) return 'high';
  if (score >= 8) return 'medium';
  return 'low';
};

const riskStyles = {
  high: 'bg-red-50 text-red-700 border-red-200',
  medium: 'bg-amber-50 text-amber-700 border-amber-200',
  low: 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

export const RiskBadge = ({ score, className }) => {
  const level = getRiskLevel(score);
  
  return (
    <span 
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border capitalize',
        riskStyles[level],
        className
      )}
    >
      {level} ({score})
    </span>
  );
};

export default RiskBadge;
